/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { BusinessSectorField } from './';
import {
    BusinessSectorFieldFromJSON,
    BusinessSectorFieldFromJSONTyped,
    BusinessSectorFieldToJSON,
} from './';
import type { CategoryField } from './';
import {
    CategoryFieldFromJSON,
    CategoryFieldFromJSONTyped,
    CategoryFieldToJSON,
} from './';
import type { ChosenProjectDescriptionField } from './';
import {
    ChosenProjectDescriptionFieldFromJSON,
    ChosenProjectDescriptionFieldFromJSONTyped,
    ChosenProjectDescriptionFieldToJSON,
} from './';
import type { DailyRateField } from './';
import {
    DailyRateFieldFromJSON,
    DailyRateFieldFromJSONTyped,
    DailyRateFieldToJSON,
} from './';
import type { DurationField } from './';
import {
    DurationFieldFromJSON,
    DurationFieldFromJSONTyped,
    DurationFieldToJSON,
} from './';
import type { ExpectedSourcingProcessField } from './';
import {
    ExpectedSourcingProcessFieldFromJSON,
    ExpectedSourcingProcessFieldFromJSONTyped,
    ExpectedSourcingProcessFieldToJSON,
} from './';
import type { ExperienceField } from './';
import {
    ExperienceFieldFromJSON,
    ExperienceFieldFromJSONTyped,
    ExperienceFieldToJSON,
} from './';
import type { FormerCompanyField } from './';
import {
    FormerCompanyFieldFromJSON,
    FormerCompanyFieldFromJSONTyped,
    FormerCompanyFieldToJSON,
} from './';
import type { InferredProjectDescriptionField } from './';
import {
    InferredProjectDescriptionFieldFromJSON,
    InferredProjectDescriptionFieldFromJSONTyped,
    InferredProjectDescriptionFieldToJSON,
} from './';
import type { InitialCategoryField } from './';
import {
    InitialCategoryFieldFromJSON,
    InitialCategoryFieldFromJSONTyped,
    InitialCategoryFieldToJSON,
} from './';
import type { JobTitleField } from './';
import {
    JobTitleFieldFromJSON,
    JobTitleFieldFromJSONTyped,
    JobTitleFieldToJSON,
} from './';
import type { KeywordField } from './';
import {
    KeywordFieldFromJSON,
    KeywordFieldFromJSONTyped,
    KeywordFieldToJSON,
} from './';
import type { LanguageField } from './';
import {
    LanguageFieldFromJSON,
    LanguageFieldFromJSONTyped,
    LanguageFieldToJSON,
} from './';
import type { OriginalProjectDescriptionField } from './';
import {
    OriginalProjectDescriptionFieldFromJSON,
    OriginalProjectDescriptionFieldFromJSONTyped,
    OriginalProjectDescriptionFieldToJSON,
} from './';
import type { ProjectTitleField } from './';
import {
    ProjectTitleFieldFromJSON,
    ProjectTitleFieldFromJSONTyped,
    ProjectTitleFieldToJSON,
} from './';
import type { RefinementCriterionField } from './';
import {
    RefinementCriterionFieldFromJSON,
    RefinementCriterionFieldFromJSONTyped,
    RefinementCriterionFieldToJSON,
} from './';
import type { SkillField } from './';
import {
    SkillFieldFromJSON,
    SkillFieldFromJSONTyped,
    SkillFieldToJSON,
} from './';
import type { StartDateField } from './';
import {
    StartDateFieldFromJSON,
    StartDateFieldFromJSONTyped,
    StartDateFieldToJSON,
} from './';
import type { UpdatedFieldName } from './';
import {
    UpdatedFieldNameFromJSON,
    UpdatedFieldNameFromJSONTyped,
    UpdatedFieldNameToJSON,
} from './';
import type { WorkConditionsAndDurationField } from './';
import {
    WorkConditionsAndDurationFieldFromJSON,
    WorkConditionsAndDurationFieldFromJSONTyped,
    WorkConditionsAndDurationFieldToJSON,
} from './';
import type { WorkConditionsField } from './';
import {
    WorkConditionsFieldFromJSON,
    WorkConditionsFieldFromJSONTyped,
    WorkConditionsFieldToJSON,
} from './';

/**
 * 
 * @export
 * @interface UpdatedField
 */
export interface UpdatedField {
    /**
     * 
     * @type {UpdatedFieldName}
     * @memberof UpdatedField
     */
    name: UpdatedFieldName;
}

/**
 * Check if a given object implements the UpdatedField interface.
 */
export function instanceOfUpdatedField(value: object): value is UpdatedField {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function UpdatedFieldFromJSON(json: any): UpdatedField {
    return UpdatedFieldFromJSONTyped(json, false);
}

export function UpdatedFieldFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdatedField {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
        if (json['name'] === 'BUSINESS_SECTOR') {
            return BusinessSectorFieldFromJSONTyped(json, true);
        }
        if (json['name'] === 'CATEGORY') {
            return CategoryFieldFromJSONTyped(json, true);
        }
        if (json['name'] === 'CHOSEN_PROJECT_DESCRIPTION') {
            return ChosenProjectDescriptionFieldFromJSONTyped(json, true);
        }
        if (json['name'] === 'DAILY_RATE') {
            return DailyRateFieldFromJSONTyped(json, true);
        }
        if (json['name'] === 'DURATION') {
            return DurationFieldFromJSONTyped(json, true);
        }
        if (json['name'] === 'EXPECTED_SOURCING_PROCESS') {
            return ExpectedSourcingProcessFieldFromJSONTyped(json, true);
        }
        if (json['name'] === 'EXPERIENCE') {
            return ExperienceFieldFromJSONTyped(json, true);
        }
        if (json['name'] === 'FORMER_COMPANY') {
            return FormerCompanyFieldFromJSONTyped(json, true);
        }
        if (json['name'] === 'INFERRED_PROJECT_DESCRIPTION') {
            return InferredProjectDescriptionFieldFromJSONTyped(json, true);
        }
        if (json['name'] === 'INITIAL_CATEGORY') {
            return InitialCategoryFieldFromJSONTyped(json, true);
        }
        if (json['name'] === 'JOB_TITLE') {
            return JobTitleFieldFromJSONTyped(json, true);
        }
        if (json['name'] === 'KEYWORD') {
            return KeywordFieldFromJSONTyped(json, true);
        }
        if (json['name'] === 'LANGUAGE') {
            return LanguageFieldFromJSONTyped(json, true);
        }
        if (json['name'] === 'ORIGINAL_PROJECT_DESCRIPTION') {
            return OriginalProjectDescriptionFieldFromJSONTyped(json, true);
        }
        if (json['name'] === 'PROJECT_TITLE') {
            return ProjectTitleFieldFromJSONTyped(json, true);
        }
        if (json['name'] === 'REFINEMENT_CRITERION') {
            return RefinementCriterionFieldFromJSONTyped(json, true);
        }
        if (json['name'] === 'SKILL') {
            return SkillFieldFromJSONTyped(json, true);
        }
        if (json['name'] === 'START_DATE') {
            return StartDateFieldFromJSONTyped(json, true);
        }
        if (json['name'] === 'WORK_CONDITIONS') {
            return WorkConditionsFieldFromJSONTyped(json, true);
        }
        if (json['name'] === 'WORK_CONDITIONS_AND_DURATION') {
            return WorkConditionsAndDurationFieldFromJSONTyped(json, true);
        }
    }
    return {
        
        'name': UpdatedFieldNameFromJSON(json['name']),
    };
}

export function UpdatedFieldToJSON(value?: UpdatedField | null, ignoreDiscriminator?: boolean): any {
    if (value == null) {
        return value;
    }
    if (!ignoreDiscriminator) {
        if (value.name === 'BUSINESS_SECTOR') {
            return BusinessSectorFieldToJSON(value as BusinessSectorField);
        }
        if (value.name === 'CATEGORY') {
            return CategoryFieldToJSON(value as CategoryField);
        }
        if (value.name === 'CHOSEN_PROJECT_DESCRIPTION') {
            return ChosenProjectDescriptionFieldToJSON(value as ChosenProjectDescriptionField);
        }
        if (value.name === 'DAILY_RATE') {
            return DailyRateFieldToJSON(value as DailyRateField);
        }
        if (value.name === 'DURATION') {
            return DurationFieldToJSON(value as DurationField);
        }
        if (value.name === 'EXPECTED_SOURCING_PROCESS') {
            return ExpectedSourcingProcessFieldToJSON(value as ExpectedSourcingProcessField);
        }
        if (value.name === 'EXPERIENCE') {
            return ExperienceFieldToJSON(value as ExperienceField);
        }
        if (value.name === 'FORMER_COMPANY') {
            return FormerCompanyFieldToJSON(value as FormerCompanyField);
        }
        if (value.name === 'INFERRED_PROJECT_DESCRIPTION') {
            return InferredProjectDescriptionFieldToJSON(value as InferredProjectDescriptionField);
        }
        if (value.name === 'INITIAL_CATEGORY') {
            return InitialCategoryFieldToJSON(value as InitialCategoryField);
        }
        if (value.name === 'JOB_TITLE') {
            return JobTitleFieldToJSON(value as JobTitleField);
        }
        if (value.name === 'KEYWORD') {
            return KeywordFieldToJSON(value as KeywordField);
        }
        if (value.name === 'LANGUAGE') {
            return LanguageFieldToJSON(value as LanguageField);
        }
        if (value.name === 'ORIGINAL_PROJECT_DESCRIPTION') {
            return OriginalProjectDescriptionFieldToJSON(value as OriginalProjectDescriptionField);
        }
        if (value.name === 'PROJECT_TITLE') {
            return ProjectTitleFieldToJSON(value as ProjectTitleField);
        }
        if (value.name === 'REFINEMENT_CRITERION') {
            return RefinementCriterionFieldToJSON(value as RefinementCriterionField);
        }
        if (value.name === 'SKILL') {
            return SkillFieldToJSON(value as SkillField);
        }
        if (value.name === 'START_DATE') {
            return StartDateFieldToJSON(value as StartDateField);
        }
        if (value.name === 'WORK_CONDITIONS') {
            return WorkConditionsFieldToJSON(value as WorkConditionsField);
        }
        if (value.name === 'WORK_CONDITIONS_AND_DURATION') {
            return WorkConditionsAndDurationFieldToJSON(value as WorkConditionsAndDurationField);
        }
    }
    return {
        
        'name': UpdatedFieldNameToJSON(value['name']),
    };
}

